// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1-fnU","menu":"Button_menu__mMNkA","primary":"Button_primary__38wr9"};